import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Banner de aviso cuando la contraseña está próxima a expirar
 * Se muestra en la parte superior del dashboard
 */
const PasswordExpirationWarning = ({ 
  daysUntilExpiration, 
  onChangePassword, 
  onDismiss 
}) => {
  // Determinar el color según los días restantes
  const getColorClasses = () => {
    if (daysUntilExpiration <= 3) {
      return {
        bg: 'bg-red-50',
        border: 'border-red-300',
        text: 'text-red-800',
        icon: 'text-red-600',
        button: 'bg-red-600 hover:bg-red-700'
      };
    } else if (daysUntilExpiration <= 7) {
      return {
        bg: 'bg-orange-50',
        border: 'border-orange-300',
        text: 'text-orange-800',
        icon: 'text-orange-600',
        button: 'bg-orange-600 hover:bg-orange-700'
      };
    } else {
      return {
        bg: 'bg-yellow-50',
        border: 'border-yellow-300',
        text: 'text-yellow-800',
        icon: 'text-yellow-600',
        button: 'bg-yellow-600 hover:bg-yellow-700'
      };
    }
  };

  const colors = getColorClasses();

  const getUrgencyMessage = () => {
    if (daysUntilExpiration === 0) {
      return '¡Su contraseña expira hoy!';
    } else if (daysUntilExpiration === 1) {
      return '¡Su contraseña expira mañana!';
    } else if (daysUntilExpiration <= 3) {
      return `¡Su contraseña expira en ${daysUntilExpiration} días!`;
    } else {
      return `Su contraseña expirará en ${daysUntilExpiration} días`;
    }
  };

  return (
    <div className={`${colors.bg} border ${colors.border} rounded-lg p-4 mb-4 shadow-sm`}>
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3 flex-1">
          <AlertTriangle className={`w-5 h-5 ${colors.icon} flex-shrink-0 mt-0.5`} />
          <div className="flex-1">
            <h3 className={`font-semibold ${colors.text} text-sm mb-1`}>
              {getUrgencyMessage()}
            </h3>
            <p className={`text-xs ${colors.text} opacity-90`}>
              Por políticas de seguridad, debe cambiar su contraseña cada 90 días. 
              Le recomendamos cambiarla ahora para evitar interrupciones en su acceso.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Button
            size="sm"
            onClick={onChangePassword}
            className={`${colors.button} text-white text-xs px-4 py-2 whitespace-nowrap`}
          >
            Cambiar Ahora
          </Button>
          {onDismiss && (
            <button
              onClick={onDismiss}
              className={`${colors.text} hover:opacity-70 transition-opacity`}
              title="Cerrar aviso"
            >
              <X size={18} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PasswordExpirationWarning;
